module.exports = __webpack_public_path__ + "node_modules/icheck/skins/minimal/yellow.png?0bd13b60";